export enum RoomsOption {
  Delete = 'delete',
  Edit = 'edit',
  Unpublish = 'unpublish',
  Publish = 'publish',
}
